import React from "react";

const FortellisTitle5 = ({ title }) => {
  return <div className="fortellis-title-5">{title}</div>;
};

export default FortellisTitle5;
